<mat-card [ngClass]="cardStatusClass" [matTooltip]="isTimeStatusVisible ? ('TOOLTIPS.Estado_Fecha_Hora' | translate) : ''" matTooltipClass="label-tooltip">
  <mat-card-header>
    <mat-card-title matTooltip="{{ cameraName }} ({{ cameraId }})"
      class="truncate"
      matTooltipClass="label-tooltip"
    >
      {{ cameraName }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="card-cam__status">
      <span
        *ngIf="isSinConteo; else statusIcon"
        class="card-cam__snowflake"
        [matTooltip]="'TOOLTIPS.Sin conteo' | translate: { tiempo: sinConteoHoras }"
        matTooltipClass="label-tooltip">
        <atom-icon [iconClass]="'fa-regular fa-snowflake'" [iconColor]="'#fff'"></atom-icon>
      </span>

      <ng-template #statusIcon>
        <mat-icon
          matTooltip="{{ 'TOOLTIPS.' + status | translate }}"
          matTooltipClass="label-tooltip"
          [ngClass]="status">
          {{ getStatusIcon() }}
        </mat-icon>
      </ng-template>
    </div>

    <atom-label [text]="ipAddress" [tooltipText]="'IP del dispositivo'"
       class="card-cam__label truncate"
    >
    </atom-label>
    <atom-label *ngIf="lastDataSent" [text]="(lastDataSent | customDate) ?? ''" [tooltipText]="'Último envío de datos'"
       class="card-cam__label truncate"
    >
    </atom-label>
    <atom-label *ngIf="lastSync" [text]="(lastSync | customDate) ?? ''" [tooltipText]="'Última sincronización'"
       class="card-cam__label truncate"
    >
    </atom-label>
  </mat-card-content>
</mat-card>
